<template>
  <div class="ven-ger-totais">
    <!-- SETA O BOTÃO DE TOTAIS -->
    <App-Button v-if="linhas.length <= 0" :cpntTexto='"Apresentar totais da pesquisa"' :cpntClass='"btn btn-sm btn-default"' @onClick="vendaGerTotaisIniciar"></App-Button>

    <!-- SETA A TABELA COM OS DADOS RECEBIDOS -->
    <App-Tabela v-else :data-time="time"
    :cpntStatus="statusGeral"
    :cpntColuna="colunas"
    :cpntLinha="linhas">
    </App-Tabela>
  </div>
</template>


<style scoped>
  .ven-ger-totais {
    text-align: center;
    max-width: 750px;
    margin: 0px auto;
    margin-top: 20px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntMontarFiltros: {
        required: false,
        default: function () {
          return (callback) => { callback([]) }
        }
      },
      cpntDemanda: {
        required: false,
        default: function () {
          return () => { return null }
        }
      },
      cpntMontarWhere: {
        required: false,
        default: function () {
          return () => { return null }
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        colunas: [],
        linhas: []
      }
    },
    methods: {
      vendaGerTotaisIniciar: function () {
        // SETA O STATUS DA PAGINA
        this.vendaGerTotaisSetarStatusGeral('carregando')
        
        // SETA OS VALORES DAS LINHAS
        this.linhas = [
          { tp: '1', tipo: 'Orçamento', qtde: 0, servico: 0, retencao: 0, produto: 0, desconto: 0, total: 0 },
          { tp: '2', tipo: (this.cpntDemanda.charAt(0).toUpperCase() + this.cpntDemanda.slice(1)), qtde: 0, servico: 0, retencao: 0, produto: 0, desconto: 0, total: 0 },
          { tp: '', tipo: 'Total', qtde: 0, servico: 0, retencao: 0, produto: 0, desconto: 0, total: 0 }
        ]

        // SETA AS COLUNAS DA TABELA
        if (this.cpntDemanda !== 'compra' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, null, null, false) === true) {
          this.colunas = [
            { mPer: 3,  chave: 'tipo',     nome: '&nbsp;' },
            { mPer: 3,  chave: 'qtde',     nome: 'Quantidade' },
            { mPer: 3,  chave: 'servico',  nome: 'Serviços' },
            { mPer: 3,  chave: 'produto',  nome: 'Produtos' },
            { mPer: 3,  chave: 'desconto', nome: 'Desconto' },
            { mPer: 3,  chave: 'total',    nome: 'Total' }
          ]
        } else {
          this.colunas = [
            { mPer: 3,  chave: 'tipo',     nome: '&nbsp;' },
            { mPer: 3,  chave: 'qtde',     nome: 'Quantidade' },
            { mPer: 3,  chave: 'produto',  nome: 'Produtos' },
            { mPer: 3,  chave: 'desconto', nome: 'Desconto' },
            { mPer: 3,  chave: 'total',    nome: 'Total' }
          ]
        }

        // BUSCA OS VALORES DAS VENDAS
        this.vendaGerTotaisBuscarVendas((retorno) => {
          for (var chave in retorno) {
            // PEGA O NUMERO DA LINHA E AGRUPA
            var indexL = ''
            if (chave === 'orcamento') {
              indexL = 0
            } else if (chave === 'venda') {
              indexL = 1
            } else if (chave === 'compra') {
              indexL = 1
            } else if (chave === 'total') {
              indexL = 2
            }

            // JUNTA OS VALORES RECEBIDOS
            this.linhas[indexL] = Object.assign(this.linhas[indexL], retorno[chave])

            // FORMATA OS VALORES RECEBIDOS
            for (var col in this.linhas[indexL]) {
              if ([ 'servico', 'retencao', 'produto', 'desconto', 'total' ].indexOf(col) !== -1) {
                this.linhas[indexL][col] = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.linhas[indexL][col].toString())
              }
            }

            // VERIFICA SE TEM ALGUM VALOR DE RETENÇÃO
            if (this.linhas[indexL].retencao !== '0,00') {
              this.linhas[indexL].servico += ' (R$ ' + this.linhas[indexL].retencao + ' retido)'
            }
          }

          // SETA O STATUS DA PAGINA
          this.vendaGerTotaisSetarStatusGeral('')
        })
      },
      vendaGerTotaisSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      vendaGerTotaisBuscarVendas: function (callback) {
        // BUSCA OS FILTROS APLICADOS
        this.cpntMontarFiltros((filtros) => {
          // INICIA O QUERYGET
          var queryGet = { type: 'list', return: 'arrayGroupByField', field: {} }

          // SETA ESSES CAMPOS PARA PODER UTILIZAR TODAS AS TABELAS NO WHERE
          queryGet.field.id_con = { a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } }
          queryGet.field.updated_user = { a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } }

          // INICIA A VARIAVEL
          var router = ''
          
          // VERIFICA AS DIFERENÇAS QUE DEVE REALIZAR
          switch (this.cpntDemanda) {
            case 'venda':
              // SETA O NOME DA ROTA QUE DEVE CHAMAR
              router = '/venda/resumo/get'

              // SETA OS CAMPOS QUE DEVE CHAMAR
              queryGet.field.cod_venda = null
              queryGet.field.id_vei = { a: '_REMOVER_', j: { id: { a: '_REMOVER_' }, ref_modelo: {  a: '_REMOVER_', j: { id_marca: {  a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } } } }, id_mod: { a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } }, id_mar: {  a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } } } }
              queryGet.field.id_pet = { a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } }
              queryGet.field.id_pco_item = { a: '_REMOVER_', j: { id: { a: '_REMOVER_' } } }

              // INICIA A VARIAVEL
              queryGet.where = { aAnd: [ { f: 'status', o: '<>', v: '3' } ] }
              break

            case 'compra':
              // SETA O NOME DA ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra/resumo/get'

              // SETA OS CAMPOS QUE DEVE CHAMAR
              queryGet.field.dem_compra = null

              // INICIA A VARIAVEL
              queryGet.where = { aAnd: [ { f: 'dem_status', o: '<>', v: '3' } ] }
              break
          }         

          // RODA EM TODOS OS FILTROS MONTADO O VALOR
          for (var indexF in filtros) {
            // PEGA O RETORNO DA FUNÇÃO
            var retorno = this.cpntMontarWhere(filtros[indexF])

            // VERIFICA SE TEM ALGUM VALOR RECEBIDO
            if ([ '', null, undefined ].indexOf(retorno) !== -1 || Object.keys(retorno).length === 0) {
              retorno = { where: filtros[indexF] }
            }

            // JUNTA OS VALORES RECEBIDOS
            if (Array.isArray(retorno.where) === true) {
              queryGet.where.aAnd = queryGet.where.aAnd.concat(retorno.where)
            } else {
              queryGet.where.aAnd.push(retorno.where)
            }
          }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
            callback(retorno)
          }, this.vendaGerTotaisSetarStatusGeral)
        })
      }
    }
  }
</script>
